<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="value"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="gradiente">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Editar noticia</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="flags.loading" dark flat @click="updateNotice">Guardar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid style="max-height: 93vh;" class="scrollDesign">
          <v-layout row wrap>
            <v-flex xs12 sm6 xl4 class="scrollDesign">
              <v-subheader>Datos generales</v-subheader>
              <v-container class="py-0">
                <v-layout row>
                  <v-flex xs12>
                    <v-textarea
                      label="Título"
                      :value="notice.title"
                      v-model="noticeForm.title"
                      name="name"
                      :error-messages="titleErrors"
                      rows="1"
                      row-height="24"
                      auto-grow
                    ></v-textarea>

                    <v-textarea
                      label="Descripción"
                      :value="notice.description"
                      v-model="noticeForm.description"
                      :error-messages="descriptionErrors"
                      rows="1"
                      row-height="24"
                      auto-grow
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-subheader>Documentos anexados</v-subheader>
              <v-container class="pt-0 px-3">
                <v-chip
                  v-for="(n, key) in noticeForm.files"
                  :key="key"
                  download="o ficheirinho de tostas.pdf"
                  v-show="n.enable"
                  close
                  @input="remove(n, key)"
                >
                  <strong>{{ n.name }}</strong>&nbsp;
                  <span>{{ (n.size/(1024*1024)).toFixed(2)+"Mb" }}</span>&nbsp;
                </v-chip>
                
                <v-flex xs12 class="mt3"></v-flex>
                
                <!-- File picker -->
                <FileAttachment v-on:selected-file="onSelectedFile" />
                <!-- File picker -->

              </v-container>

              <v-subheader v-if="notice.type == 'E'">Datos del evento</v-subheader>
              <v-list three-line v-show="notice.type == 'E'">
                <v-list-tile avatar v-show="notice.type == 'E'">
                  <v-list-tile-avatar>
                    <img :src="require('@/assets/notices/SKLB-Evento.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <DateTimePicker
                      :errorMessages="dateStartErrors"
                      v-model="noticeForm.startDate"
                      titleDate="Fecha de inicio"
                      titleTime="Hora de inicio"
                    ></DateTimePicker>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile avatar v-show="notice.type == 'E'">
                  <v-list-tile-avatar>
                    <img :src="require('@/assets/notices/SKLB-Evento.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <DateTimePicker
                      :errorMessages="dateEndErrors"
                      v-model="noticeForm.endDate"
                      titleDate="Fecha de término"
                      titleTime="Hora de término"
                    ></DateTimePicker>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-list-tile avatar v-if="notice.type == 'E'">
                <v-list-tile-avatar>
                  <img :src="require('@/assets/mapIcons/if_map-marker_3688470.png')" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Lugar</v-list-tile-title>
                  <v-list-tile-sub-title>{{ notice.place }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar v-if="notice.type == 'E'">
                <v-list-tile-avatar>
                  <v-checkbox color="primary" hide-details v-model="noticeForm.assistanceRequired"></v-checkbox>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Asistencia del tutor</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span v-if="noticeForm.assistanceRequired">Requerido</span>
                    <span v-else>No requerido</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile avatar v-if="notice.type == 'E'">
                <v-list-tile-avatar>
                  <v-icon v-if="notice.confirmParent" color="green" large>check</v-icon>
                  <v-icon v-else color="red" large>clear</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>Confirmación del tutor</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span v-if="notice.confirmParent">Requerido</span>
                    <span v-else>No requerido</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex xs12 sm6 xl8>
              <v-container grid-list-xl>
                <v-layout row wrap justify-center>
                  <v-flex
                    xs4
                    style="border-radius: 50%;"
                    id="parentContainerNoticeImage2"
                    class="gradiente"
                  >
                    <label id="img_edit_notice_default2">
                      <v-img :src="require('@/assets/panel/modals/AddPhotoIcon@3x.png')"></v-img>
                    </label>
                  </v-flex>

                  <v-flex xs12></v-flex>

                  <!-- Image input -->
                  <v-flex xs8>
                    <input
                      ref="file"
                      name="file"
                      multiple
                      type="file"
                      style="display:none"
                      accept="image/jpeg, image/png"
                      @change="onFileChange($event.target.name, $event.target.files)"
                    />
                    <v-btn
                      block
                      class="gradiente"
                      style="border-radius: 33px;"
                      dark
                      @click="launchFilePicker"
                      :disabled="disableButton"
                    >Añadir</v-btn>
                  </v-flex>
                  <!-- Image input -->

                  <v-flex xs12 lg8>
                    <!-- New images -->
                    <v-container fluid grid-list-xs>
                      <v-layout wrap row justify-center>
                        <v-slide-y-transition v-for="(image, key) in noticeForm.imgs" :key="key">
                          <v-flex :key="key" xs12 xl7>
                            <v-card class="d-flex align-center" dark>
                              <v-img :src="image">
                                <v-btn color="primary" @click="noticeForm.imgs.splice(key,1)" icon>
                                  <v-icon>clear</v-icon>
                                </v-btn>
                              </v-img>
                            </v-card>
                          </v-flex>
                        </v-slide-y-transition>
                      </v-layout>
                    </v-container>
                    <!-- New images -->
                    
                    <!-- Current images -->
                    <v-container fluid grid-list-xs v-if="noticeForm.imageStorage && noticeForm.imageStorage.length > 0"
                    >
                      <v-layout wrap row justify-center>
                        <v-slide-y-transition v-for="(image, key) in noticeForm.imageStorage" :key="key">
                          <v-flex :key="key" xs12 xl8>
                            <v-card class="d-flex align-center" dark>
                              <v-img :src="image.miniObjUrl">
                                <v-btn icon color="primary" @click="deleteImage(image, key)">
                                  <v-icon>clear</v-icon>
                                </v-btn>
                              </v-img>
                            </v-card>
                          </v-flex>
                        </v-slide-y-transition>
                      </v-layout>
                    </v-container>
                    <!-- Current images -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <loading v-model="flags.loading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
    <error v-model="errors.maxExceeded.show" :text="errors.maxExceeded.message"></error>
    <error v-model="errors.wrongImage.show" :text="errors.wrongImage.message"></error>
  </v-layout>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import loading from "../Dialogs/Loading";
import success from "../Dialogs/Success";
import error from "../Dialogs/Error";
import DateTimePicker from "../Sections/Notices/Tools/DateTimePicker2";
import FileAttachment from "../Tools/FileAttachment";
export default {
  components: {
    DateTimePicker,
    FileAttachment,
    loading,
    success,
    error
  },
  props: ["value", "notice"],
  filters: {
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  validations: {
    noticeForm: {
      title: { required },
      description: { required },
      startDate: { required },
      endDate: {
        validateDateEnd() {
          if (this.noticeForm.endDate) {
            return this.noticeForm.startDate < this.noticeForm.endDate
              ? true
              : false;
          }
          return true;
        }
      }
    }
  },
  data: () => ({
    noticeForm: {
      startDate: "",
      endDate: "",
      img: [],
      imgs: [],
      deletedImageStorage: []
    },
    flags: {
      loading: false
    },
    toast: {
      failed: false,
      success: false
    },
    modals: {
      image: false
    },
    errors: {
      maxExceeded: {
        show: false,
        message: ""
      },
      wrongImage: {
        show: false,
        message: ""
      }
    }
  }),
  watch: {
    notice() {
      this.noticeForm = this.notice;
      this.noticeForm.startDate = new Date(this.notice.startDate);
      if (this.notice.endDate != null) {
        this.noticeForm.endDate = new Date(this.notice.endDate);
      }
      if (this.notice.img == null || this.notice.img.length == 0) {
        this.noticeForm.img = [];
      }
      if (this.notice.imageStorage) {
        // cloning array
        this.noticeForm.imageStorage = this.notice.imageStorage.filter(el => !!el);
      } else {
        this.noticeForm.imageStorage = [];
      }
      this.noticeForm.deletedImageStorage = [];

      if (this.notice.files) {
        this.noticeForm.files = this.notice.files.filter(el => !!el);
      }
    }
  },
  methods: {
    close() {
      this.$emit("input", !this.value);
    },
    deleteImage(imageStorage, index) {
      if (!this.noticeForm.imageStorage) return;
      this.noticeForm.imageStorage.splice(index, 1);
      if (!this.noticeForm.deletedImageStorage) {
        this.noticeForm.deletedImageStorage = [];
      }
      this.noticeForm.deletedImageStorage.push(imageStorage.id);
    },
    onSelectedFile(file) {
      if (!this.noticeForm.files) {
        this.noticeForm.files = [];
      }

      file.enable = true;
      this.noticeForm.files.push(file);
      this.$forceUpdate();
    },
    updateNotice() {
      this.$v.noticeForm.$touch();
      if (!this.$v.noticeForm.$invalid) {
        this.flags.loading = true;
        var notice = {
          id: this.noticeForm.id,
          title: this.noticeForm.title,
          description: this.noticeForm.description,
          startDate: this.noticeForm.startDate.getTime(),
          endDate: this.noticeForm.endDate ? this.noticeForm.endDate.getTime() : null,
          imgs: this.noticeForm.imgs,
          deleteImages: this.noticeForm.deletedImageStorage,
          assistanceRequired: this.noticeForm.assistanceRequired,
          files: this.noticeForm.files
        };

        this.$store
          .dispatch("notice/updateNotice", notice)
          .then(response => {
            this.close();
            this.flags.loading = false;
            this.toast.success = true;
          })
          .catch(error => {
            this.flags.loading = false;
            this.toast.failed = true;
          });
      }
    },
    remove(n, index) {
      if (n.id) {
        this.noticeForm.files[index].enable = false;
      } else {
        this.noticeForm.files.splice(index, 1);
      }
      this.$forceUpdate();
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    onFileChange(fieldName, fileList) {
      var ignoredFiles = [];
      var wrongFiles = [];
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        if (this.noticeForm.imgs.length + i + 1 > this.maxAllowedImages) {
          ignoredFiles.push(file.name);
        } else {
          this.toDataURL(file)
            .then(result => {
              this.noticeForm.imgs.push(result);
            })
            .catch(error => {
              console.log("Cannot read file", error);
              wrongFiles.push(file.name);
            });
        }
      }

      if (ignoredFiles.length === 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado una imagen debido a que se ha excedido el límite.`
        };
      } else if (ignoredFiles.length > 1) {
        this.errors.maxExceeded = {
          show: true,
          message: `Se han ignorado ${ignoredFiles.length} imágenes debido a que se ha excedido el límite.`
        };
      }

      if (wrongFiles.length === 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar la siguiente imagen: ${wrongFiles[0]}`
        };
      } else if (wrongFiles.length > 1) {
        this.errors.wrongImage = {
          show: true,
          message: `No fue posible procesar las siguientes imágenes: [${wrongFiles.join(
            ", "
          )}]`
        };
      }
    },
    toDataURL(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
  },
  computed: {
    titleErrors() {
      const errors = [];
      if (!this.$v.noticeForm.title.$dirty) return errors;
      !this.$v.noticeForm.title.required && errors.push("Título requerido");
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.noticeForm.description.$dirty) return errors;
      !this.$v.noticeForm.description.required &&
        errors.push("Descripción requerida");
      return errors;
    },
    dateStartErrors() {
      const errors = [];
      if (!this.$v.noticeForm.startDate.$dirty) return errors;
      !this.$v.noticeForm.startDate.required &&
        errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.$v.noticeForm.endDate.$dirty) return errors;
      !this.$v.noticeForm.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser mayor a la de inicio");
      return errors;
    },
    studentsFromNotice() {
      return this.notice.students.filter(student => {
        for (let lvl of this.notice.levels) {
          if (lvl.id == student.level.id) {
            return false;
          }
        }
        for (let gg of this.notice.groups) {
          if (gg.id == student.gg.id) {
            return false;
          }
        }
        return true;
      });
    },
    disableButton() {
      return (
        this.noticeForm.imgs && this.noticeForm.imgs.length >= this.maxAllowedImages
      );
    },
    maxAllowedImages() {
      if (!this.noticeForm.imageStorage) {
        return 5;
      }
      return 5 - this.noticeForm.imageStorage.length;
    }
  }
};
</script>

<style>
</style>
